export enum RecentSearchLocalStorageKeys {
    project = 'lastProjectSearches',
    person = 'lastProfileSearches',
    bufferAdvancedFilterProject = 'bufferAdvancedFilterProject',
    bufferAdvancedFilterPeople = 'bufferAdvancedFilterPeople',
}
